import type { TOC } from '@ember/component/template-only';

import BarLoader from 'webapp/components/bar-loader';

interface CommonListLoaderComponentInterface {
	Args: object;
}

const CommonListLoaderComponent: TOC<CommonListLoaderComponentInterface> = <template>
	<div class="infinite-scroll-info"><BarLoader /> loading more items</div>
</template>;

export default CommonListLoaderComponent;
